import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../assets/css/Signin.scss";
import { LoginLogo } from "../assets/icons";
import ButtonLoader from "../atoms/buttonLoader";
import { forgotPassword } from "../services/service";
import { CustomToast } from "../atoms/toastMessage";
import buildLoginBg from "../assets/images/dashboard/buildloginbg.svg";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    try {
      const response = await forgotPassword({ email: values.email });

      if (response) {
        CustomToast({
          type: "success",
          message: "OTP sent to your email successfully",
        });
        // Navigate to OTP verification page with email
        navigate("/verify-otp", { state: { email: values.email } });
      }
    } catch (error) {
      const errorMessage = error.message || "Failed to send OTP";
      CustomToast({
        type: "error",
        message: errorMessage,
      });
    }
    setLoading(false);
    setSubmitting(false);
  };

  return (
    <div className="fluid-container">
      <div className="sign-page" style={{ backgroundImage: `url(${buildLoginBg})` }}>
        <div className="sign-page-background d-flex align-items-center">
          <div
            className="row m-0 sign-page-background-row"
            style={{ justifyContent: "center", alignItems: "center" }}
          >
            <div className="custome_offset px-lg-5 mahzen-logo d-flex justify-content-center flex-column">
              <div style={{ height: "100%", width: "100%" }}>
                <div className="row mx-lg-5 px-lg-5 pt-3 pb-2 siginup-inner py-5">
                  <div className="w-full d-flex justify-content-center">
                    <div className="login-logo d-flex justify-content-center align-items-end">
                      {LoginLogo}
                    </div>
                  </div>
                  <div className="col-12 mb-3 d-flex justify-content-center">
                    <p className="mb-0 text-[#1E3A8A] font-semibold text-[28px]">
                      Forgot Password
                    </p>
                  </div>
                  <div className="col-12 mb-3 d-flex justify-content-center text-center">
                    <p className="mb-0 text-[#64748B] text-[14px]">
                      Enter your email address and we'll send you an OTP to reset your password
                    </p>
                  </div>
                  <Formik
                    initialValues={{ email: "" }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ isSubmitting }) => (
                      <Form className="w-100">
                        <div className="col-12 mt-2 signup-input-label">
                          <Field
                            type="text"
                            name="email"
                            placeholder="Email"
                            className="form-control pl-3"
                          />
                          <ErrorMessage
                            name="email"
                            component="p"
                            className="signup-staric-color"
                          />
                        </div>

                        <div className="w-full flex justify-center items-center">
                          <button
                            type="submit"
                            className="w-[94.5%] bg-[#F97316] h-[52px] rounded-[4px] mt-6 flex items-center justify-center"
                            disabled={isSubmitting || isLoading}
                          >
                            {isLoading ? (
                              <ButtonLoader color="#FFFFFF" />
                            ) : (
                              <p className="font-semibold text-[20px] text-white">
                                Send OTP
                              </p>
                            )}
                          </button>
                        </div>

                        <div className="col-12 mt-4 mb-2 text-center">
                          <p className="mb-0 text-[14px]">
                            Remember your password?{" "}
                            <Link
                              to="/signin"
                              className="text-[#F97316] hover:underline"
                            >
                              Sign In
                            </Link>
                          </p>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
